export const environment = {
  production: true,
  AUTHPORTAL_API_URL: "https://accounts.rinknet.com/api/",
  PRESSROOM_API_URL: 'https://pressroom.rinknet.com/',
  ONESIGNAL_APP_ID: "d02454b9-d8fe-4e4d-9e01-217c09c7a0a6",
  IMAGE_URL: "http://pc.rinknet.com/images/",
  PRINT_LINES_URL: "https://reports.rinknet.com/pressroomlineups.aspx",
  TWITTER_AUTHORIZE_URL: "https://api.twitter.com/oauth/authorize",
  TWITTER_URL: "https://twitter.com",
  OPS_SIGN_IN_URL: "https://ops.rinknet.com/#/signin",
  ONERINK_URL: "https://app.1rink.com/#/home/dashboard",
  DEFAULT_PRINT_LAYOUT_ID: 2000
};
